<template>
  <div class="bg-white rounded-xl shadow-lg p-6 max-w-lg mx-auto text-gray-800">
    <h2 class="text-xl font-semibold text-gray-700 border-b pb-2 mb-4">{{ title }}</h2>

    <!-- Group Name -->
    <div class="mb-4">
      <label class="block text-sm font-medium text-gray-700 mb-1">
        Group Name <span class="text-red-600">*</span>
      </label>
      <input
        v-model="name"
        type="text"
        required
        placeholder="Enter group name"
        class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition-all duration-150"
      />
    </div>

    <!-- Description -->
    <div class="mb-6">
      <label class="block text-sm font-medium text-gray-700 mb-1">
        Description
      </label>
      <textarea
        v-model="description"
        rows="3"
        placeholder="Brief description of this group"
        class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition-all duration-150 resize-none"
      ></textarea>
    </div>

    <!-- Footer Actions -->
    <div class="flex justify-end gap-3">
      <button
        type="button"
        @click="$root.$emit('hide_modal')"
        class="px-4 py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100 transition-all duration-150"
      >
        Cancel
      </button>
      <button
        type="submit"
        @click="saveRecord"
        class="px-4 py-2 rounded-lg bg-teal-600 text-white hover:bg-teal-700 transition-all duration-150 font-medium"
      >
        Save
      </button>
    </div>
  </div>
</template>

<script>
import GraphQl from "@/services/graphql.service";

export default {
  name: "NewGroup",
  props: {
    breadcrumb: { type: Boolean, default: true },
    title: { type: String, default: "New Customer Group" },
    eName: String,
    eDescription: String,
    id: String,
  },
  data() {
    return {
      name: this.eName,
      description: this.eDescription,
      errors: [],
    };
  },
  methods: {
    saveRecord() {
      const params = [
        this.id ? `id:"${this.id}"` : "",
        `name:"${this.name}"`,
        `description:"${this.description}"`,
      ]
        .filter(Boolean)
        .join(", ");

      const query = `mutation {
        createCustomerGroup(${params}) {
          code
          message
          recordId
        }
      }`;

      GraphQl.sendRequest(query)
        .then((res) => {
          const result = res.createCustomerGroup;
          const eventType =
            result.code === 200 ? "alert_success" : "alert_error";
          this.$root.$emit(eventType, [result.message]);
          if (result.code === 200) this.$root.$emit("hide_modal");
        })
        .finally(() => this.$root.$emit("refresh", "groups"));
    },
  },
};
</script>
